import { post, get} from "../http";

export const fetchiigClientInfoListForPip = () => get(`/isp/client-info/list-pip/for/iig`);
export const fetchgetSmsBalanceSinglePartnerInfo = () => get(`/sms/balance/for/single/partner`);
export const fetchiigClientBillInfoListForPip = (payload) => get(`/isp/client-bill/report/list-pip/for/iig?billStatus=${payload.billStatus}&billMonth=${payload.billMonth}&billYear=${payload.billYear}`);